/**
 * Formatação monetária.
 *
 * As views Blade quebravam o valor em parte inteira e centavos para estilizar
 * cada uma com um tamanho de fonte diferente (`floor($valor)` + `substr(number_format(...), -2)`).
 * `splitCurrency` reproduz isso; `formatCurrency` é o formato completo usado no
 * resumo do cartão (`number_format($valor, 2, ',', '.')`).
 */

/** `1234.5` → `"1.234,50"` (sem o prefixo "R$"). */
export function formatCurrency(value: number | string | null | undefined): string {
  const amount = Number(value ?? 0);
  if (!Number.isFinite(amount)) return '0,00';
  return amount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** `49.9` → `{ integer: '49', cents: '90' }`. */
export function splitCurrency(value: number | string | null | undefined): {
  integer: string;
  cents: string;
} {
  const amount = Number(value ?? 0);
  const safe = Number.isFinite(amount) ? amount : 0;
  const fixed = safe.toFixed(2);
  const [integerPart, centsPart] = fixed.split('.');
  return {
    integer: Number(integerPart).toLocaleString('pt-BR'),
    cents: centsPart,
  };
}
